/** @format */

import React, { useState, useCallback } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'

import { Courses } from 'views/Courses'
import TopIcon from 'assets/icons_js/Top'

import styles from './Body.module.css'

export const Body = () => {
  const [showOnScroll, handleShowScroll] = useState(false)

  useScrollPosition(({ currPos }) => (currPos.y * -1 >= 100 ? handleShowScroll(true) : handleShowScroll(false)))
  const handleTopScroll = useCallback(() => window.scrollTo({ top: 0, behavior: 'smooth' }), [])

  return (
    <div className={styles.wrapper}>
      <div className={styles.scrollButtonWrap} style={{ opacity: +showOnScroll }}>
        <TopIcon className={styles.scrollButton} onClick={handleTopScroll} />
        <p className={styles.scrollButtonHoverBlock} />
      </div>
      <Switch>
        <Route path="/" component={Courses} />
        <Redirect to="/" />
      </Switch>
    </div>
  )
}
